<script setup lang="ts">
const { lite } = defineProps<{
    lite?: boolean;
}>();
const route = useRoute();

const i18n = useI18n();

const isHotel = computed(() => route.path === '/hotel');
</script>

<template>
    <div class="container tickets-wrap">
        <h2 v-show="!isHotel && !lite">{{ i18n.t('BusyWay.title') }}</h2>
        <p v-show="!isHotel && !lite">
            <strong>خرید بلیط</strong>&nbsp;از&nbsp;
            <a href="https://mrbilit.com/">مِستربلیط</a>&nbsp;به راحتی آب خوردن
            است! کافی است مسیر و تاریخ را مشخص کنید تا مِستربلیط تمامی نتایج
            مورد نیازتان را جست و جو کند و ارزانترین قیمت‌های بلیط را به شما
            پیشنهاد دهد. مِستربلیط اولین وب سایتی است که خرید&nbsp;
            <a href="https://mrbilit.com/plane-ticket">بلیط هواپیما</a>،&nbsp;
            <a href="https://mrbilit.com/train-ticket">بلیط قطار</a>
            &nbsp;و&nbsp;
            <a href="https://mrbilit.com/bus-ticket">بلیط اتوبوس</a>&nbsp;را
            یکجا امکان‌پذیر کرده است. این وب سایت خرید اینترنتی دارای نماد
            اعتماد الکترونیک دو ستاره از مرکز توسعه تجارت الکترونیک بوده و زیر
            نظر سازمان‌های مربوطه فعالیت می‌کند. اپلیکیشن اندروید و iOS
            مِستربلیط نیز برای تلفن همراه تهیه شده و قابل دانلود می‌باشد. خرید
            بلیط هواپیما که در بسیاری از موارد امری دشوار به نظر می‌رسد در این
            سامانه به سهولت قابل انجام است. پس از جستجو در کمترین زمان و به
            راحتی می‌توانید
            <a href="https://mrbilit.com/international-flights">
                بلیط هواپیما خارجی
            </a>
            و داخلی خود را خریداری نمایید. با مِستربلیط، به راحتی و فقط با چند
            کلیک،&nbsp;
            <a href="https://mrbilit.com/charter">رزرو بلیط هواپیما چارتری</a>
            &nbsp;و سیستمی، قطار و اتوبوس با ارزان‌ترین قیمت‌ها میسر است.
        </p>
    </div>
</template>

<style scoped lang="scss">
.tickets-wrap {
    margin: 0 auto;
    h2 {
        text-align: center;
        font-style: normal;
        @include font-weight(bold);
        font-size: 18px;
        line-height: 28px;
        color: usePalette($p-cool-gray, $p-800);
        margin: 0 0 7.5px 0;
    }

    h3,
    b {
        margin: 16px 0;
        // text
        font-style: normal;
        @include font-weight(bold);
        font-size: 18px;
        line-height: 28px;
        text-align: right;
        color: usePalette($p-cool-gray, $p-800);
    }

    p {
        font-style: normal;
        @include font-weight(300);
        font-size: 12px;
        line-height: 19px;
        text-align: center;
        color: usePalette($p-cool-gray, $p-800);
    }

    a {
        color: usePalette() !important;
        text-decoration: none !important;
    }
}

// plane tickets

@media (max-width: $app-mobile-max-width) {
    .tickets-wrap {
        padding: 0 16px;
        @include mobile-only {
            padding: 0;
            > * {
                padding-left: 16px;
                padding-right: 16px;
            }
            > a {
                display: block;
            }
        }
    }

    .tickets-wrap p {
        text-align: justify;
    }
}
</style>
